<div class="brand-menu mx-auto rounded-md bg-white shadow-md">
  <div class="@container flex h-[400px]">
    <div class="min-h-full w-full overflow-y-auto">
      <!-- <ul class="container grid h-[450px] w-full grid-cols-3 overflow-y-auto"> -->
      <ul class="container overflow-y-auto md:columns-2 lg:columns-3">
        <li
          *ngFor="let brand of brands"
          class="w-full cursor-pointer border-l border-l-primary-main py-1 hover:border-l-8 hover:bg-primary-lightest">
          <div
            [routerLink]="['/product']"
            [queryParams]="{ brands: brand.id }"
            routerLinkActive="router-link-active"
            class="w-full px-4 py-1 font-normal">
            {{ brand.name }}
          </div>
        </li>
      </ul>
    </div>
    <div class="w-[600px] pl-0">
      <div
        class="min-h-full w-full overflow-hidden rounded-r-md bg-[url(/assets/images/brand.webp)] bg-cover bg-no-repeat"></div>
    </div>
  </div>
</div>
